import React from 'react';
import PropTypes from 'prop-types';

import { Container, Row } from '../../base/Grid';
import Button from '../../base/Button';

import {
  GeneralSection,
  GeneralSectionCol,
  SectionHeading,
  SectionSubheading,
} from './styles';

export const GeneralSectionComponent = ({
  id,
  variant,
  innerColProps,
  innerContent,
  ctaButtonVariant,
  ctaButtonText,
  ctaButtonLinkHref,
  headline,
  headlineProps,
  subheading,
  subheadingProps,
}) => (
  <GeneralSection id={`${id}-section-container`} variant={variant}>
    <Container>
      <Row align="center">
        <GeneralSectionCol {...innerColProps}>
          <SectionHeading {...headlineProps}>{headline}</SectionHeading>
          {subheading && (<SectionSubheading {...subheadingProps}>{subheading}</SectionSubheading>)}
          {innerContent && innerContent}
          {ctaButtonLinkHref && (
            <a aria-label={ctaButtonText} href={ctaButtonLinkHref}>
              <Button
                id={`${id}-cta-button`}
                variant={ctaButtonVariant}
                role="link">
                {ctaButtonText}
              </Button>
            </a>
          )}
        </GeneralSectionCol>
      </Row>
    </Container>
  </GeneralSection>
);

GeneralSectionComponent.propTypes = {
  /** Id for the section */
  id: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  /** Override the default inner col props */
  innerColProps: PropTypes.object,
  /** Override default typography props for the headline */
  headlineProps: PropTypes.object,
  /** Optional subheading to display under headline - will not display if not provided */
  subheading: PropTypes.string,
  /** Override default typography props for the subheading - only used if subheading is provided */
  subheadingProps: PropTypes.object,
  /** Additional content, code, or component to display under the headline/subheading - will not display if not provided */
  innerContent: PropTypes.object,
  /** Button varient for the CTA - only used if ctaBttonLinkHref is provided */
  ctaButtonVariant: PropTypes.string,
  /** Button text for the CTA - only used if ctaBttonLinkHref is provided */
  ctaButtonText: PropTypes.string,
  /** Link to send user when CTA is clicked - IF NOT PROVIDED, CTA BUTTON IS HIDDEN */
  ctaButtonLinkHref: PropTypes.string,
};

GeneralSectionComponent.defaultProps = {
  variant: 'primary',
  innerColProps: { xsmall: 12 },
  headlineProps: { component: 'h2', variant: 'h3' },
  subheadingProps: { component: 'p' },
  buttonVariant: 'primary',
  buttonText: 'Get Started',
};

export default GeneralSectionComponent;
